import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  font-family: 'Roboto', sans-serif;
  padding-bottom: 20px;
  line-height: 1.6;
`
